/*jshint multistr: true */

import './modules/video_player.js';
import '../lib/messages_hr.js';

$(function () {

    function autostartTopGifts() {

        var $topgifts = $('.js_topgifts'),
            $fold = $topgifts.parents('.js_topgiftsFold'),
            $catBtn = $topgifts.find('.js_giftCatBtn'),
            tabsLength = $catBtn.length,
            $list = $topgifts.find('.js_giftList'),
            randNum = Math.floor(Math.random() * (tabsLength));

        if (!$catBtn.length) { return; }

        $fold.removeClass('hidden');

        $catBtn.on('click', function (e) {

            e.preventDefault();

            var $parent = $(this).parent('.js_giftTab');
            randNum = $parent.index();

            $parent.addClass('is_active')
                .siblings('.is_active')
                .removeClass('is_active');


            $list.find('.topgifts__products_list').eq(randNum)
                .addClass('is_active')
                .siblings('.is_active')
                .removeClass('is_active');

        });

        $catBtn.eq(randNum).trigger('click');

    }

    function autostartVideoCard() {

        var $videoCard = $('.js_videoCard'),
            $activeCard,
            holaActive = false;

        if (!$videoCard.length) { return; }

        $videoCard.each(function () {

            //define variables that are used for both play and stop video
            var $card = $(this),
                $cardLink = $card.find('.card__link'),
                $closeBtn = $card.find('.js_closeVideo'),
                $placeholder,
                $video,
                $player,
                videoCode = '';

            $cardLink.on('click', function (e) {

                e.preventDefault();

                var $link = $(this),
                    target = $(e.target);

                // is the play button clicked or not
                // if not - go to article
                if (!target.hasClass('js_playVideo')) {

                    document.location.href = $link.attr('href');

                } else {

                    if (holaActive) {

                        $activeCard.find('.js_closeVideo').trigger('click');

                    } else {

                        holaActive = true;

                    }

                    // theese are defined here because of the video clone made after each video stop
                    $placeholder = $card.find('.js_videoPlaceholder'),
                        $video = $card.find('.js_video'),
                        $player = jwplayer($video.attr('id'));

                    // clone video embed code
                    if (videoCode === '') videoCode = $video.clone();

                    $video.addClass('inline_jwplayer');

                    inlinePlayerInit();

                    setTimeout(() => {

                        $card.addClass('playing_video');
                        $activeCard = $card;
                        $player.play();

                    }, 200);

                }

            });

            $closeBtn.on('click', function () {

                if ($card.hasClass('playing_video')) {

                    $card.removeClass('playing_video');
                    $player.stop();
                    $player.remove();
                    $placeholder.empty().append(videoCode);

                }

            });

        })

    }

    autostartTopGifts();
    autostartVideoCard();
});
